import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { MatColors } from '@ecap3/template-atlas';
import { CalendarEventModel } from '../../models/calendar.model';

@Component({
    selector: 'platfrom-calendar-event-form-dialog',
    templateUrl: './event-form.component.html',
    styleUrls: ['./event-form.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class PlatfromCalendarEventFormDialogComponent {
    event: CalendarEventModel;
    dialogTitle: string;
    eventForm: UntypedFormGroup;
    action: string;
    hasPermissionToEdit: boolean;
    hasPermissionToDelete: boolean;
    presetColors = MatColors.presets;

    constructor(
        public dialogRef: MatDialogRef<PlatfromCalendarEventFormDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private readonly formBuilder: UntypedFormBuilder
    ) {
        this.event = data.event;
        this.action = data.action;
        this.hasPermissionToEdit = data.hasPermissionToEdit;
        this.hasPermissionToDelete = data.hasPermissionToDelete;

        if (this.action === 'edit') {
            this.dialogTitle = this.event && this.event.editTitle || this.event.title;
        }
        else {
            this.dialogTitle = 'New Event';
            this.event = new CalendarEventModel({
                start: data.date,
                end: data.date
            });
        }

        this.eventForm = this.createEventForm();
    }

    createEventForm(): any {
        return new UntypedFormGroup({
            title: new UntypedFormControl(this.event.title),
            start: new UntypedFormControl(this.event.start),
            end: new UntypedFormControl(this.event.end),
            allDay: new UntypedFormControl(this.event.allDay),
            color: this.formBuilder.group({
                primary: new UntypedFormControl(this.event.color.primary),
                secondary: new UntypedFormControl(this.event.color.secondary)
            }),
            meta:
                this.formBuilder.group({
                    location: new UntypedFormControl(this.event.meta.location),
                    notes: new UntypedFormControl(this.event.meta.notes)
                }),
        });

    }
}
